var map = {
	"./admin_settings.png": 1358,
	"./catalog.png": 1359,
	"./catalog_order.png": 1360,
	"./cms.png": 1361,
	"./component-fields/Asset.png": 1362,
	"./component-fields/Blocks.png": 1363,
	"./component-fields/Boolean.png": 1364,
	"./component-fields/Date-time.png": 1365,
	"./component-fields/LInk.png": 1366,
	"./component-fields/Markdown.png": 1367,
	"./component-fields/Multi asset.png": 1368,
	"./component-fields/Multi options.png": 1369,
	"./component-fields/Number.png": 1370,
	"./component-fields/Richtext.png": 1371,
	"./component-fields/Single options.png": 1372,
	"./component-fields/Table.png": 1373,
	"./component-fields/Text area.png": 1374,
	"./component-fields/Text.png": 1375,
	"./components.png": 1376,
	"./configuration.png": 1377,
	"./contents.png": 1378,
	"./custom_order.png": 1379,
	"./customer_credits.png": 1380,
	"./dashboard.png": 1381,
	"./dashboard_available_credit.png": 1382,
	"./dashboard_due_soon.png": 1383,
	"./dashboard_invoices.png": 1384,
	"./dashboard_market.png": 1385,
	"./dashboard_messages.png": 1386,
	"./dashboard_new_arrivals.png": 1270,
	"./dashboard_new_catalog_order.png": 1265,
	"./dashboard_new_custom_order.png": 1267,
	"./dashboard_new_estimate.png": 1266,
	"./dashboard_new_payment.png": 1269,
	"./dashboard_new_repair.png": 1268,
	"./dashboard_orders.png": 1387,
	"./dashboard_past_due.png": 1388,
	"./dashboard_quotes.png": 1389,
	"./dashboard_sales_orders.png": 1390,
	"./dashboard_total_payable.png": 1391,
	"./estimate.png": 1392,
	"./financials.png": 1393,
	"./home.png": 1394,
	"./invoices.png": 1395,
	"./media_library.png": 1396,
	"./move.png": 1397,
	"./order_creation.png": 1398,
	"./orders.png": 1399,
	"./payment-methods/amex.png": 1189,
	"./payment-methods/discover.png": 1188,
	"./payment-methods/mastercard.png": 1187,
	"./payment-methods/visa.png": 1186,
	"./payment.png": 1400,
	"./product_catalog.png": 1401,
	"./quote-icon.png": 1402,
	"./quotes.png": 1403,
	"./repair_order.png": 1404,
	"./sales_orders.png": 1405,
	"./status_tracking.png": 1406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1208;